import React, { Fragment } from 'react';
import Select from 'react-select';

import ErrorMessage from './errorMessage';

const HHTeamInvitationSelect = props => {
  const {
    field,
    form: { setFieldValue, touched, errors },
    otherProps = {}
  } = props;

  const hasError = !!(touched[field.name] && errors[field.name]);

  return (
    <Fragment>
      <Select.AsyncCreatable
        value={field.value}
        onChange={(selectedOption) => {
          setFieldValue(field.name, selectedOption);
        }}
        loadOptions={() => {}}
        promptTextCreator={(label) => `Invite ${label}`}
        {...otherProps}
      />
      { hasError && (<ErrorMessage error={errors[field.name]} />) }
    </Fragment>
  );
};

export default HHTeamInvitationSelect;



// WEBPACK FOOTER //
// ./src/components/forms/fields/hhTeamInvitationSelect.js